import { z } from 'zod/v3';
import { errorMap } from '../../common/utils';

import translations from './ValidationDashboardUpdateSchema.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';

const { addTranslations, t } = i18nNsFactory(
  'validation-dashboard-update-schema',
);
addTranslations(translations);

export const ValidationDashboardUpdateSchema = z.object({
  name: z.string(errorMap(() => t('validation.name.required'))).min(1),
  description: z.string().nullable(),
});
